<p-fluid>
  <form [formGroup]="form()" class="flex flex-col gap-2">
    @if (!hideTipoRepresentacaoFormField()) {
      <div class="flex flex-col">
        <label [for]="fieldId + '-tipo-representacao'"
        >Tipo de Representação@if (editMode()) {
          <span class="required">*</span>
        }
        </label>
        @if (isTipoRepresentacaoConcessionaria || form().get('representacaoUsuarioConcessionaria')?.value) {
          <input
            pInputText
            [id]="fieldId + '-tipo-representacao'"
            formControlName="representacaoUsuarioConcessionaria"
            [ngClass]="{ 'readonly-input': !editMode() }"
            readonly
          />
        } @else if (editMode()) {
          <p-select
            [inputId]="fieldId + '-tipo-representacao'"
            [options]="tipoRepresentacaoOptions"
            optionLabel="label"
            optionValue="value"
            formControlName="tipoRepresentacao"
            appendTo="body"
            [filter]="true"
            filterBy="label"
            placeholder="Selecione"
          />
        } @else {
          <input
            pInputText
            [id]="fieldId + '-tipo-representacao'"
            [value]="getNomeFromEnum('tipoRepresentacao')"
            [ngClass]="{ 'readonly-input': !editMode() }"
            readonly
          />
        }
        @if (isFormControlInvalid("tipoRepresentacao")) {
          <span class="required text-sm">Campo obrigatório.</span>
        }
      </div>
    }

    <div class="flex flex-col">
      <label [for]="fieldId + '-nome-solicitante'"
      >Nome do Solicitante@if (editMode()) {
        <span class="required">*</span>
      }
      </label>
      <input
        pInputText
        [id]="fieldId + '-nome-solicitante'"
        maxlength="255"
        formControlName="nomeSolicitante"
        [ngClass]="{ 'readonly-input': !editMode() }"
        placeholder="Digite"
      />
      @if (isFormControlInvalid("nomeSolicitante")) {
        <span class="required text-sm">Campo obrigatório.</span>
      }
    </div>

    <div class="flex flex-col">
      <label [id]="fieldId + '-justificativa-label'" [for]="fieldId + '-justificativa'"
      >Justificativa@if (editMode()) {
        <span class="required">*</span>
      }
      </label>
      <app-custom-editor [control]="asFormControl('justificativa')"
                         [inputId]="fieldId + '-justificativa'"
                         [labelledBy]="fieldId + '-justificativa-label'"/>
      @if (isFormControlInvalid("justificativa")) {
        <span class="required text-sm">Campo obrigatório.</span>
      }
    </div>

    @if (editMode() || form().get("existeProcessoSei")?.value) {
      <div class="flex items-center gap-2">
        <p-checkbox
          formControlName="existeProcessoSei"
          [ngClass]="{ 'readonly-input': !editMode() }"
          [binary]="true"
          inputId="existeProcessoSei"
        />
        <label for="existeProcessoSei">Existe Processo SEI!</label>
      </div>
    }

    @if (form().get("existeProcessoSei")?.value) {
      <div class="flex flex-col">
        <label [for]="fieldId + '-numero-processo-sei'"
        >Número do Processo SEI!@if (editMode()) {
          <span class="required">*</span>
        }
        </label>
        <p-input-mask
          [inputId]="fieldId + '-numero-processo-sei'"
          mask="999.99999999/9999-99"
          placeholder="000.00000000/0000-00"
          [ngClass]="{ 'readonly-input': !editMode() }"
          formControlName="numeroProcessoSei"
        />
        @if (isFormControlInvalid("numeroProcessoSei")) {
          <span class="required text-sm">Campo obrigatório.</span>
        }
      </div>

      <div class="flex flex-col">
        <label [for]="fieldId + '-tipo-processo-sei'"
        >Tipo do Processo@if (editMode()) {
          <span class="required">*</span>
        }
        </label>
        @if (!editMode()) {
          <input
            pInputText
            [id]="fieldId + '-tipo-processo-sei'"
            [value]="getNomeFromEnum('tipoProcessoSei')"
            readonly
            class="readonly-input"
          />
        } @else {
          <p-select
            [inputId]="fieldId + '-tipo-processo-sei'"
            [options]="tipoProcessoOptions"
            optionLabel="label"
            optionValue="value"
            placeholder="Selecione"
            filterBy="label"
            [filter]="true"
            appendTo="body"
            [ngClass]="{ 'readonly-input': !editMode() }"
            formControlName="tipoProcessoSei"
          />
          @if (isFormControlInvalid("tipoProcessoSei")) {
            <span class="required text-sm">Campo obrigatório.</span>
          }
        }
      </div>

      @if (form().get("tipoProcessoSei")?.value?.id === ID_TIPO_PROCESSO_SEI_OUTROS) {
        <div class="flex flex-col">
          <label for="descricaoProcesso">Descrição@if (editMode()) {
            <span class="required">*</span>
          }</label>
          <input
            id="descricaoProcesso"
            pInputText
            placeholder="Digite"
            maxlength="255"
            [ngClass]="{ 'readonly-input': !editMode() }"
            formControlName="descricaoProcesso"
          />
          @if (isFormControlInvalid("descricaoProcesso")) {
            <span class="required text-sm">Campo obrigatório.</span>
          }
        </div>

      }
    }
  </form>
</p-fluid>
